import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { NAV_KEYS, useLang } from "@/i18n";
import { LangSwitch } from "@/components/site/LangSwitch";

const linkCls = (isActive) =>
  `nav-link text-[12px] tracking-[0.16em] uppercase font-medium text-[#1A2522] ${isActive ? "active" : ""}`;
const mobileCls = (isActive) =>
  `text-sm tracking-[0.18em] uppercase font-medium ${isActive ? "text-[#374F49] underline underline-offset-8" : "text-[#1A2522]"}`;

export const Header = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const { t, to } = useLang();
  const isActive = (key) => pathname === to(key) || pathname === to(key).replace(/\/$/, "");
  useEffect(() => setOpen(false), [pathname]);
  return (
    <header data-testid="site-header" className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#F8F6F0]/80 border-b border-[#D3CEC4]/60">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 h-20 flex items-center justify-between gap-6">
        <Link to={to("home")} data-testid="logo-link" className="flex flex-col leading-none group">
          <span className="font-serif text-2xl sm:text-[23px] font-medium tracking-tight text-[#1A2522] group-hover:text-[#374F49] transition-colors">ONKOLIFE</span>
          <span className="text-[10px] tracking-[0.28em] uppercase text-[#7A857F] mt-1 font-medium">{t.header.tagline}</span>
        </Link>
        <div className="flex items-center gap-8">
          <nav className="hidden lg:flex items-center gap-7" data-testid="primary-nav">
            {NAV_KEYS.map((k) => (
              <NavLink key={k} end to={to(k)} data-testid={`nav-link-${k}`} className={linkCls(isActive(k))}>
                {t.nav[k]}
              </NavLink>
            ))}
          </nav>
          <div className="flex items-center gap-3">
            <LangSwitch />
            <button
              data-testid="mobile-menu-toggle"
              aria-label={t.header.menu}
              aria-expanded={open}
              className="lg:hidden inline-flex items-center justify-center w-10 h-10 rounded-full border border-[#D3CEC4] text-[#1A2522]"
              onClick={() => setOpen(!open)}
            >
              <span className="block w-5 h-px bg-current relative before:content-[''] before:absolute before:left-0 before:w-5 before:h-px before:bg-current before:-top-1.5 after:content-[''] after:absolute after:left-0 after:w-5 after:h-px after:bg-current after:top-1.5"></span>
            </button>
          </div>
        </div>
      </div>
      {open && (
        <div className="lg:hidden border-t border-[#D3CEC4]/60 bg-[#F8F6F0]/95 backdrop-blur-xl" data-testid="mobile-menu">
          <div className="px-6 py-6 flex flex-col gap-5">
            {NAV_KEYS.map((k) => (
              <NavLink key={k} end to={to(k)} onClick={() => setOpen(false)} data-testid={`mobile-nav-link-${k}`} className={mobileCls(isActive(k))}>
                {t.nav[k]}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};
